import { EditNotificationAreaDTO } from '../models/NotificationArea'
import { TicketRepository } from '../repositories/TicketRepository'

export function EditNotificationAreaAssociationCase(
  ticketRepository: TicketRepository
) {
  return async function ({
    associationId,
    data
  }: {
    associationId: string
    data: EditNotificationAreaDTO
  }) {
    return await ticketRepository.editNotificationAreaAssociation({
      associationId: associationId,
      data: data
    })
  }
}
